import React, { useState } from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { Icon } from 'ui';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import * as actions from 'actions/pathBuilder';
import LinkButton from 'components/shared/LinkButton';
import InfoTooltip from 'components/shared/InfoTooltip';
import Section, { SectionHeader } from '../Section';
import CompletionTimeForm from './CompletionTimeForm';
import DisplayCompletionTime from './DisplayCompletionTime';

const parseNumber = value => {
  if (value === '') return '';
  return Number(value).toString();
};

const convertToMinute = valueInSeconds => {
  if (valueInSeconds === null) return '';

  return (valueInSeconds / 60).toString(10);
};

const CompletionTime = ({
  pathId,
  estimatedMinutesToComplete,
  setCompletionTime,
  isCertification,
  features,
}) => {
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const handleAutoCalculateCompletionTime = () => {
    if (!loading) {
      setLoading(true);

      request
        .get(routes.PATH_COMPLETION_TIME(pathId))
        .then(response => {
          setLoading(false);
          setCompletionTime(
            convertToMinute(response.estimated_seconds_to_complete),
          );
        })
        .catch(e => {
          setLoading(false);
          console.error(e);
        });
    }
  };

  const handleCompletionTimeChange = e => {
    setCompletionTime(parseNumber(e.target.value));
  };

  const handleToggleEditMode = () => {
    setEditMode(true);
  };

  const handleUpdateCompletionTime = e => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);

    request
      .put(routes.PATH(pathId), { estimatedMinutesToComplete })
      .then(response => {
        setLoading(false);
        setEditMode(false);
        setCompletionTime(response.estimatedMinutesToComplete);
      })
      .catch(error => {
        setLoading(false);
        console.error(error);
      });
  };

  return (
    <Section>
      <SectionHeader className="d-f jc-sb ai-fs" htmlFor="pathCompletionTime">
        <span>
          {t('paths.path_builder.sidebar.completion_time.description')}{' '}
          <InfoTooltip
            tooltip={
              isCertification
                ? t(
                    'certifications.certification_builder.sidebar.completion_time_tooltip',
                  )
                : t('paths.path_builder.sidebar.completion_time.tooltip')
            }
          />
          <br />
          {t('common.time')}
        </span>
      </SectionHeader>
      {!estimatedMinutesToComplete && !editMode && (
        <LinkButton
          onClick={handleToggleEditMode}
          className="u-linkBtn fz-base fw-n td-n mt-8 ta-l"
        >
          <Icon name="add" className="mr-8" />
          {t('paths.path_builder.sidebar.completion_time.add')}
          <br />
          <span className="ml-20">{t('common.time')}</span>
        </LinkButton>
      )}
      {editMode && (
        <CompletionTimeForm
          loading={loading}
          estimatedMinutesToComplete={estimatedMinutesToComplete}
          onUpdateCompletionTime={handleUpdateCompletionTime}
          onCompletionTimeChange={handleCompletionTimeChange}
          onAutoCalculateCompletionTime={handleAutoCalculateCompletionTime}
        />
      )}
      {estimatedMinutesToComplete && !editMode && (
        <DisplayCompletionTime
          estimatedMinutesToComplete={estimatedMinutesToComplete}
          onToggleEditMode={handleToggleEditMode}
        />
      )}
    </Section>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => {
  const estimatedMinutesToComplete =
    pathBuilder.estimatedMinutesToComplete === null
      ? ''
      : pathBuilder.estimatedMinutesToComplete.toString();
  return {
    pathId: pathBuilder.id,
    estimatedMinutesToComplete,
    isCertification: !!get('certification')(pathBuilder),
  };
};

const mapDispatchToProps = {
  setCompletionTime: actions.setEstimatedMinutesToComplete,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompletionTime);
